import apiClient from './client';

// Family API
export const familiesApi = {
  // Get current family
  getFamily: () => apiClient.get('/guardians/family'),

  // Create a new family
  createFamily: (data) => apiClient.post('/guardians/families', { family: data }),

  // Update family
  updateFamily: (data) => apiClient.patch('/guardians/family', { family: data }),
};

// Children API
export const childrenApi = {
  // List all children
  list: () => apiClient.get('/guardians/children'),

  // Get a single child
  get: (id) => apiClient.get(`/guardians/children/${id}`),

  // Create a child
  create: (data) => apiClient.post('/guardians/children', { child: data }),

  // Update a child
  update: (id, data) => apiClient.patch(`/guardians/children/${id}`, { child: data }),

  // Delete a child
  delete: (id) => apiClient.delete(`/guardians/children/${id}`),

  // Update child password
  updatePassword: (id, password) =>
    apiClient.patch(`/guardians/children/${id}/password`, { child: { password } }),
};

// Family Users (Guardians) API
export const familyUsersApi = {
  // List all family users
  list: () => apiClient.get('/guardians/family_users'),

  // Add a guardian
  add: (email, role) => apiClient.post('/guardians/family_users', { guardian: { email, role } }),

  // Remove a guardian
  remove: (id) => apiClient.delete(`/guardians/family_users/${id}`),
};

// Daily Targets API
export const dailyTargetsApi = {
  // Get daily target for a child
  get: (childId) => apiClient.get(`/guardians/children/${childId}/daily_target`),

  // Create daily target
  create: (childId, data) =>
    apiClient.post(`/guardians/children/${childId}/daily_target`, { daily_target: data }),

  // Update daily target
  update: (childId, data) =>
    apiClient.patch(`/guardians/children/${childId}/daily_target`, { daily_target: data }),

  // Apply to all children
  applyToAll: (childId, data) =>
    apiClient.post(`/guardians/children/${childId}/daily_target/apply_to_all`, { daily_target: data }),
};

// Settings API
export const settingsApi = {
  // Get guardian settings (feature flags)
  get: () => apiClient.get('/guardians/settings'),
};

// Pending Activities API (for wizard flow)
export const pendingActivitiesApi = {
  // Add a pending activity
  add: (childId, templateKey) =>
    apiClient.post(`/guardians/children/${childId}/pending_activities`, { template_key: templateKey }),

  // Remove a pending activity
  remove: (childId, templateKey) =>
    apiClient.delete(`/guardians/children/${childId}/pending_activities/${templateKey}`),

  // Bulk update pending activities (replaces all with given list)
  bulkUpdate: (childId, templateKeys) =>
    apiClient.put(`/guardians/children/${childId}/pending_activities/bulk_update`, { template_keys: templateKeys }),
};
